import styled from "styled-components";
import { ThemeSwitch } from "@itb/ui";

interface ThemeNavbarItemMobileProps {
  children?: React.ReactNode;
  mobile?: boolean;
}

const StyledThemeNavbarItemMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.text};
  cursor: pointer;
  box-sizing: border-box;
  line-height: 22px;
  border-bottom: 1px solid ${props => props.theme.colors.border};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ThemeText = styled.span`
  /* No specific styles needed here, as it will inherit from parent */
`;

const ThemeNavbarItemMobile: React.FC<ThemeNavbarItemMobileProps> = () => {
  return (
    <StyledThemeNavbarItemMobile>
      <ThemeText>Theme</ThemeText>
      <ThemeSwitch />
    </StyledThemeNavbarItemMobile>
  );
};

export default ThemeNavbarItemMobile;
